import { Avatar, AvatarGroup, Button } from "@heroui/react";
import React, { useState } from "react";
import ViewModalPopup from "../view-modal-popup";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import { formatNumber } from "../../../utils/common";

dayjs.extend(utc);

const ViewCard = ({ data }) => {
  const [isOpenPopup, setIsOpenPopup] = useState(false);

  const handleOpenModal = () => {
    setIsOpenPopup(!isOpenPopup);
  };

  const endDateUTC = data?.end_date ? dayjs.utc(data.end_date) : null;

  return (
    <>
      <div className="border border-[#C2C2C2] rounded-xl overflow-hidden h-fit">
        {/* Header */}
        <div className="bg-black min-h-5 flex items-center justify-center px-2 py-1">
          <p className="m-0 text-xs text-white text-center leading-tight">
            <span className="whitespace-nowrap">Voting ended on:</span>{" "}
            <span className="font-medium whitespace-nowrap">
              {endDateUTC ? endDateUTC.format("MMMM D, YYYY") : "N/A"}
            </span>
          </p>
        </div>

        {/* Body */}
        <div className="p-2.5 flex flex-col gap-5">
          <div className="flex items-center justify-between">
            {/* Status */}
            <div className="flex items-center gap-1.5 w-fit h-6 py-1 px-2.5 rounded cursor-pointer bg-[#F01444]">
              <div className="w-2 h-2 rounded-full bg-white"></div>
              <p className="m-0 text-[0.625rem] font-medium text-black">
                Ended
              </p>
            </div>

            {/* Votes */}
            <div className="bg-[#E9E9E9] h-6 flex items-center gap-1.5 px-2 rounded">
              {data?.total_votes > 0 && (
                <AvatarGroup>
                  {Array.from({ length: Math.min(3, data.total_votes) }).map(
                    (_, idx) => {
                      const image = data.total_votes_profile_images?.[idx];
                      return (
                        <Avatar
                          key={idx}
                          src={typeof image === "string" ? image : undefined}
                          classNames={{
                            base: "ring-0 w-5 h-5 border border-white data-[focus-visible=true]:translate-x-0 data-[hover=true]:translate-x-0"
                          }}
                        />
                      );
                    }
                  )}
                </AvatarGroup>
              )}
              <p className="m-0 text-black text-[0.5rem] font-medium">
                {formatNumber(data?.total_votes || 0)}
              </p>
            </div>
          </div>

          {/* Title */}
          <h6 className="m-0 text-base font-medium text-black line-clamp-2 min-h-[3rem]">
            {data?.name}
          </h6>

          {/* Button */}
          <Button
            className="bg-yellowbuy border border-black rounded h-7 mt-auto"
            onPress={handleOpenModal}
          >
            View Detail
          </Button>
        </div>
      </div>

      {/* Modal */}
      {isOpenPopup && (
        <ViewModalPopup
          isOpen={isOpenPopup}
          onOpenChange={handleOpenModal}
          data={data}
        />
      )}
    </>
  );
};

export default ViewCard;
